import { render, staticRenderFns } from "./Play.vue?vue&type=template&id=2afbf14e&"
import script from "./Play.vue?vue&type=script&lang=js&"
export * from "./Play.vue?vue&type=script&lang=js&"
import style0 from "./Play.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports